var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:{ 'wgu-app': true, 'wgu-app-embedded': _vm.isEmbedded },attrs:{"id":"wgu-app","data-app":""}},[_c('router-view'),_c('notifications',{staticClass:"centered-notifications",attrs:{"width":400}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }